// Libraries
import { useState, useRef, useEffect } from 'react';

// MD2 PRO
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import Card from '@mui/material/Card';

// @mui
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';

// Components
import LeftArea from './sections/LeftArea';
import RightArea from './sections/RightArea';
function AaroContractPage({ production, relatedID, aaroQueries, setValue }) {
    // Check if production data is available
    if (!production) {
        return (
            <MDBox mt={4} display="flex" justifyContent="center" alignItems="center" height="60vh">
                <Card>
                    <MDBox p={4} textAlign="center">
                        <CircularProgress color="info" />
                        <MDTypography variant="h6" mt={2}>
                            Üretim bilgileri yükleniyor...
                        </MDTypography>
                    </MDBox>
                </Card>
            </MDBox>
        );
    }

    return (
        <MDBox mt={4}>
            <Grid container spacing={3}>
                {/* Left Sidebar */}
                <Grid
                    size={{
                        xs: 12,
                        lg: 8
                    }}>
                    <LeftArea
                        production={production}
                        relatedID={relatedID}
                        aaroQueries={aaroQueries}
                        setValue={setValue}
                    />
                </Grid>

                {/* Right Sidebar */}
                <Grid
                    size={{
                        xs: 12,
                        lg: 4
                    }}>
                    <RightArea production={production} relatedID={relatedID} aaroQueries={aaroQueries} />
                </Grid>
            </Grid>
        </MDBox>
    );
}

export default AaroContractPage;
